import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    visible : true,
    pcIs: document.documentElement.clientWidth >= 1000,
  },
  mutations: {
    setvisible (state,value) {
      this.state.visible = value
    }
  },
  actions: {
  },
  modules: {
  }
})
